import React, { useContext, useState } from "react";
import "./PlanCardComponent.css";
import {
  faAngleRight,
  faCircleInfo,
  faHeart,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Discount_Lottie from "../../animation/Discount_Lottie/Discount_Lottie";
import RedRoundBtn from "../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import Plan_Details_Modal from "../../Common_Component/Common_Modal/Plan_Details_Modal/Plan_Details_Modal";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import parse from "html-react-parser";
const PlanCardComponent = ({ val }) => {
  const data = [
    {
      title: "Life Cover",
      value: "₹25 L",
    },
    {
      title: "Cover till age",
      value: "70 Yrs",
    },
    {
      title: "Claim settled",
      value: "99.2%",
    },
  ];

  const navigate = useNavigate();

  const [activeButton, setActiveButton] = useState("");

  const [addToWishlist, setaddToWishlist] = useState(false);

  const [showModal, setShowModal] = useState(false);

 

  const { IMG_URL } = useContext(Context);
  return (
    <section className="PlanCardComponent">
      <div className="row">
        <div className="col-md-2 col-sm-6 me-0 ms-0 p-0 order-md-1 order-sm-1">
          <div className="company_info_main_div">
            <p className="top_most_text">
              {val?.income_status === 1
                ? " Income proof required"
                : " Income proof not required"}
            </p>

            <div
              className="company_info_div"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <div className="img_holder">
                {/* <img src='\assets\Image\aboutus\partner\img8.png' className='company_img' />
                 */}
                <img src={`${IMG_URL}${val?.image}`} className="company_img" />
              </div>
              <p className="company_name">{val?.name}</p>
            </div>
          </div>
        </div>

        <div className="col-md-8 col-sm-12 me-0 ms-0 p-0 order-md-2 order-sm-3">
          <div className="plan_info_main_div">
            <div className="main_top_heading">
              <div className="row">
                {/* {data?.map((item) => {
                                    return (
                                        <div className='col-sm-4 col-6'>
                                            <div className='plan_info_top'>
                                                <p className='title_text'>{item?.title}</p>
                                                <p className='value_text'>{item?.value}</p>
                                            </div>
                                        </div>
                                    )
                                })} */}
                <div className="col-sm-4 col-6">
                  <div className="plan_info_top">
                    <p className="title_text">Life Cover</p>
                    <p className="value_text">{val?.life_cover}</p>
                  </div>
                </div>
                <div className="col-sm-4 col-6">
                  <div className="plan_info_top">
                    <p className="title_text">Cover till age</p>
                    <p className="value_text">{val?.cover_till_age}</p>
                  </div>
                </div>
                <div className="col-sm-4 col-6">
                  <div className="plan_info_top">
                    <p className="title_text">Claim settled</p>
                    <p className="value_text">{val?.claim_settled}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="select_main_div">
              <div className="row">
                <div className="col-sm-4 col-6">
                  <div
                    className={`dropdwon_main_div add_on_div ${
                      activeButton === "add_on" ? "active" : ""
                    }`}
                    // className='dropdwon_main_div add_on_div'

                    onClick={() => setActiveButton("add_on")}
                  >
                    <div className="dropdwon_div">
                      <p
                        className={`dropdown_text ${
                          activeButton === "add_on" ? "active" : ""
                        }`}
                      >
                        {
                          val?.f_i_add_ons?.filter(
                            (addOn) => addOn.type === "Free"
                          ).length
                        }{" "}
                        Free Add on
                      </p>
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={faSortUp}
                          className={`icon ${
                            activeButton === "add_on" ? "active" : ""
                          }`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 col-6">
                  <div
                    className={"refund_div"}
                    onClick={() => setActiveButton("refund")}
                  >
                    <div
                      className={`dropdwon_div ${
                        activeButton === "refund" ? "active" : ""
                      }`}
                    >
                      <p
                        className={`dropdown_text ${
                          activeButton === "refund" ? "active" : ""
                        }`}
                      >
                        Full Refund of Premium
                      </p>
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={faSortDown}
                          className={`icon ${
                            activeButton === "refund" ? "active" : ""
                          }`}
                        />
                      </div>
                    </div>
                    <div className="note_div">
                      <p className="note_text">Zero Cost</p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 col-6">
                  <div
                    className="dropdwon_main_div"
                    onClick={() => {
                      setShowModal(true);
                    }}
                  >
                    <div className="dropdwon_div">
                      <p className="dropdown_text">Plan Details</p>
                      <div className="icon_holder">
                        <FontAwesomeIcon icon={faSortUp} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {activeButton === "refund" ? (
              <div className="premium_main_div">
                <p className="info_text"> {parse(val?.refund_premium) || ""}</p>
                {/* <p className="info_text">
                  Zero cost plan allows you to take all your premiums back at a
                  particular age. Enjoy life cover when you need it, and get all
                  your premiums back when your responsibilities are over. Free
                  of Cost, Full Benefit-truly Zero Cost!
                </p>

                <p className="blue_text">
                  Premiums back during 60-64 yrs of age
                </p>

                <p className="how_work_text">See how it works?</p> */}
              </div>
            ) : activeButton === "add_on" ? (
              <div className="free_add_on_content_div">
                <div className="row">
                  <div className="col-5">
                    <div className="add_on_div ">
                      <p className="add_on_title">
                        {" "}
                        {
                          val?.f_i_add_ons?.filter(
                            (addOn) => addOn.type === "Free"
                          ).length
                        }{" "}
                        Free Add on
                      </p>
                      {val?.f_i_add_ons
                        ?.filter((addOn) => addOn.type === "Free")
                        .map((val1) => (
                          <p className="checkbox_div" key={val1.id}>
                            <Form.Check
                              type="checkbox"
                              name="name"
                              label={val1?.name}
                            />
                          </p>
                        ))}
                    </div>
                  </div>

                  <div className="col-7">
                    <div className="add_on_div second_div">
                      <p className="add_on_title">
                        {" "}
                        {
                          val?.f_i_add_ons?.filter(
                            (addOn) => addOn.type === "Paid"
                          ).length
                        }{" "}
                        Paid Add ons
                      </p>

                      {val?.f_i_add_ons
                        ?.filter((addOn) => addOn.type === "Paid")
                        .map((val1) => (
                          <p className="checkbox_div" key={val1.id}>
                            <Form.Check
                              type="checkbox"
                              name="name"
                              label={`${val1?.name} ₹${parseFloat(
                                val1?.rate
                              )?.toFixed(0)}`}
                            />
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="discount_main_div">
              <div className="left_div">
                <div className="dis_lottie_holder">
                  <Discount_Lottie />
                </div>

                <p className="discount_text">{(
                    ((val?.f_i_amounts[0]?.offline_amount -
                      val?.f_i_amounts[0]?.online_amount) /
                      val?.f_i_amounts[0]?.offline_amount) *
                    100
                  ).toFixed(0)}
                  % discount included</p>
              </div>
              {/* <div className="see_div">
                <p className="see_text">See how</p>
              </div> */}
            </div>
          </div>
        </div>

        <div className="col-md-2 col-sm-6 me-0 ms-0 p-0 order-md-3 order-sm-2">
          <div className="pricing_main_div">
            {/* <div className="heart_icon_div">
              <FontAwesomeIcon
                icon={faHeart}
                className={`heart_icon ${addToWishlist ? "active" : ""}`}
                onClick={() => {
                  setaddToWishlist(!addToWishlist);
                }}
              />
            </div> */}

            <div
              className="btn_holder"
              onClick={() => {
                navigate("/plan-purchase", { state: { val } });
              }}
            >
              <RedRoundBtn
                btn_name={`₹ ${val?.f_i_amounts[0]?.online_amount}/${val?.f_i_amounts[0]?.f_insurance_type?.name}`}
                icon={faAngleRight}
              />
            </div>

            <div className="footer_text">
              <p className="saving_text">Online Saving</p>
              <div className="footer_price_div">
                <p className="price_text">
                  ₹
                  {(
                    (val?.f_i_amounts[0]?.offline_amount -
                      val?.f_i_amounts[0]?.online_amount) /
                    1000
                  ).toFixed(1)}
                  K
                </p>

                <p className="info_text">
                  <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    overlay={
                      <Tooltip id="tooltip-bottom">
                        <div className="tooltip_div">
                          <p className="inner_text">
                            Offline Premium : Rs.
                            {val?.f_i_amounts[0]?.offline_amount}
                          </p>
                          <p className="inner_text">
                            Online Premium : Rs.
                            {val?.f_i_amounts[0]?.online_amount}
                          </p>
                          <p className="inner_text">
                            Total saving of Rs.{" "}
                            {(
                              (val?.f_i_amounts[0]?.offline_amount -
                                val?.f_i_amounts[0]?.online_amount) /
                              1000
                            ).toFixed(1)}
                            K over 1 yr
                          </p>
                        </div>
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faCircleInfo} className="icon" />
                  </OverlayTrigger>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Plan_Details_Modal
      IMG_URL={IMG_URL}
      val={val}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default PlanCardComponent;
